import { Grid, Typography, Box, debounce, Link } from "@mui/material";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import "../assets/styles/common-styles.scss";
import { DataGridComponent } from "../components/common/DataGridComponent";
import { GridColDef, GridSortModel } from "@mui/x-data-grid-pro";
import { useAudit } from "../hooks/useAudit";
import { useSnackbar } from "../hooks/useSnackbar";
import { formatDateTime } from "../constants/dateFormats";
import { useAppDispatch } from "./../store";

import { useNavigate } from "react-router-dom";
import { setAuditDetails } from "../store/slices/auditSlice";
const AuditTrail: React.FunctionComponent<any> = () => {
  const [rowData, setRowData] = useState([]);
  const { handleError } = useSnackbar();
  const [rowsCount, setRowsCount] = useState<number>(0);

  const dispatch = useAppDispatch();
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 20,
  });
  const [filterObj, setFilterObject] = useState("");
  const { getAudit, auditData, auditIsLoading, auditIsError, auditError } =
    useAudit();
  const [sortModel, setSortModel] = useState<GridSortModel>([
    { field: "activity_datetime", sort: "desc" },
  ]);
  const handleSortModelChange = useCallback(
    debounce((model: GridSortModel) => {
      setSortModel(
        model ? model : [{ field: "activity_datetime", sort: "asc" }]
      );
    }, 300),
    []
  );
  const getLoginHistory = (from: number, size: number, filterObj?: any) => {
    if (!sortModel || sortModel.length === 0) {
      setSortModel([{ field: "activity_datetime", sort: "asc" }]);
    }
    getAudit({
      from,
      size,
      value: filterObj && filterObj?.quickFilter ? filterObj?.quickFilter : "",
      sort_by: sortModel?.[0]?.field,
      sort_order: sortModel?.[0]?.sort,
      data: filterObj && filterObj?.advanceFilter,
    });
  };

  useEffect(() => {
    if (sortModel.length === 0) {
      setSortModel([{ field: "activity_datetime", sort: "asc" }]);
    }
  }, [sortModel]);

  useEffect(() => {
    if (paginationModel?.pageSize) {
      const { page, pageSize } = paginationModel;
      if (page * pageSize > rowsCount - 1) {
        getLoginHistory(0, pageSize, filterObj);
      } else {
        getLoginHistory(page * pageSize, pageSize, filterObj);
      }
    }
  }, [paginationModel, filterObj]);

  useEffect(() => {
    if (auditData && auditData?.count > 0) {
      setRowsCount(auditData?.count);
      setRowData(
        auditData?.result?.map((item: any) => {
          return {
            ...item,
            id: crypto.randomUUID(),
          };
        })
      );
    } else if (auditData?.count == 0) {
      setRowsCount(0);
      setRowData([]);
    }
  }, [auditData]);

  useEffect(() => {
    if (auditIsError) {
      setRowData([]);
      setRowsCount(0);
      const error: any = auditError;
      handleError(error);
    }
  }, [auditIsError]);

  const navigate = useNavigate();

  const columns: GridColDef[] = useMemo(
    () => [
      {
        field: "activity_datetime",
        headerName: "Activity Time",
        minWidth: 200,
        type: "dateTime",
        valueFormatter: (value: any) => {
          return value || value !== null ? formatDateTime(value) : new Date(0);
        },
        renderCell: (params: any) => (
          <>
            {params.row.audit_activity === "View" ? (
              params.row.activity_datetime ? (
                formatDateTime(params.row.activity_datetime)
              ) : (
                "-"
              )
            ) : (
              <Link
                onClick={() => {
                  dispatch(setAuditDetails(params.row));
                  navigate(`/audit/${params.row.activity_datetime}`);
                }}
              >
                {params.row.activity_datetime
                  ? formatDateTime(params.row.activity_datetime)
                  : "-"}
              </Link>
            )}
          </>
        ),
      },
      {
        field: "created_by",
        headerName: "Email",
        minWidth: 120,
        flex: 1,
      },
      {
        field: "audit_activity",
        headerName: "Activity",
        minWidth: 100,
        flex: 1,
      },
      {
        field: "screen_viewed",
        headerName: "Screen",
        minWidth: 100,
        flex: 1,
      },

      {
        field: "module",
        headerName: "Type",
        minWidth: 100,
        flex: 1,
      },
      {
        field: "entity_id",
        headerName: "ID",
        minWidth: 100,
        flex: 1,
      },
    ],
    []
  );

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs>
          <Typography variant="h4" gutterBottom>
            Audit Trail
          </Typography>
        </Grid>
      </Grid>
      <Box
        className="dataGridWrapBox"
        sx={{ width: "100%", height: "calc(100vh - 160px)" }}
      >
        <DataGridComponent
          columns={columns}
          rows={rowData ?? []}
          showQuickFilter
          paginationMode="server"
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          loading={auditIsLoading}
          rowsCount={rowsCount}
          filterMode="server"
          filterValues={(data: any) => setFilterObject(data)}
          sortingMode="server"
          sortModel={sortModel}
          onSortModelChange={handleSortModelChange}
          disableRowSelectionOnClick
          exportFileName="Audit_Trail_List"
          columnVisibility={{
            audit_activity: true,
            entity_id: true,
          }}
        />
      </Box>
    </>
  );
};

export default AuditTrail;
